










































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VantivResponse } from '@/models/payment/vantivresponse';
import { PaymentReceiptResponse } from '@/models/payment/payment.response';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { paymentService } from '@/shared';

@Component({
  computed: {},
})
export default class PaymentResponsePage extends Base {
  public loading: boolean = false;
  public errorMsg: string = '';
  public storeId: number = 0;
  public txHeaderId: string = '';
  public txDetailId: string = '';
  public status: string = '';
  public TransactionSetupID: string = '';
  public paymentResponse: PaymentReceiptResponse = {};
  public mounted() {
    this.txHeaderId = this.$route.query.txHeaderId as string;
    this.txDetailId = this.$route.query.txDetailId as string;
    if (this.txHeaderId) {
      this.getPaymentStatus(this.txHeaderId);
    } else {
      this.showAlert(
        false,
        this.$t('arPaymentResponse.alertTransactionIdEmpty')
      );
    }
  }

  public async getPaymentStatus(txHeaderId: string): Promise<void> {
    try {
      this.loading = true;
      const response = await paymentService.getPaymentStatus(txHeaderId);
      this.paymentResponse = response;
      if (
        this.paymentResponse.paymentDetail.status === 'Approved' ||
        this.paymentResponse.paymentDetail.status === 'PartialApproved'
      ) {
        // tslint:disable-next-line:max-line-length
        this.showAlert(true, this.$t('arPaymentResponse.alertPaymentSuccess'));
      } else {
        if (this.paymentResponse.paymentDetail.status != 'Pending') {
          this.showAlert(true, response.paymentDetail.status);
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
